import { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

//MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

//Our Includes
import { imageExist }  from '../../../assets/js/init';
import { AnimatedText, CustomButton } from '../../../assets/component/initComponent';
import useInView from '../../../hooks/useInView';

const Advantages = ({ navTrigger }) => { //viewOnce = true,

	//InView Hook
	const [sectionRef, inView] = useInView();
	const controls = useAnimation();

	//Ref
	const hasAnimatedOnScroll = useRef(false);

	//Effect
	//Trigger Animation for Nav Click
	useEffect(() => {
		let isActive = true;

		const replay = async () => {
			if (!navTrigger) return;

			await controls.start('hidden');
			if (!isActive) return;

			await controls.start('visible');
			if (!isActive) return;
		};

		replay();

		return () => {
			isActive = false;
		};
	}, [navTrigger, controls]);

	useEffect(() => {
		if (inView && !hasAnimatedOnScroll.current) {
			controls.start('visible');
			hasAnimatedOnScroll.current = true; // lock it
		}
	}, [inView, controls]);

	const content = [
		{
			title: 'Wide Range of Tools',
			img: '/tools.gif'
		},
		{
			title: 'Available Anywhere',
			img: '/availability.gif'
		},
		{
			title: 'For Every Age & Stage',
			img: '/person.gif'
		},
		{
			title: 'No Ads. No Distractions',
			img: '/noads.gif'
		},
		{
			title: 'Beginner-Friendly Interface',
			img: '/heart.gif'
		}
	];

	const containerVariant = {
		hidden: {
			opacity: 0,
			y: 50
		},
		visible: {
			opacity: 1,
			y: 0,
			scale: 1,
			transition: {
				delay: 0.4,
				duration: 2,
				ease: [0.22, 1, 0.36, 1]
			}
		}
	};

	const textVariant = {
		hidden: {
			opacity: 0,
			// x: -140,
			scale: 0.5,
			y: 250
		},
		visible: {
			opacity: 1,
			// x: 0,
			scale: 1,
			y: 250,
			transition: {
				duration: 2,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	return (
		<Container ref={sectionRef} className='containerFull' sx={{ padding:{ md:0, sm:'20px', xs:'20px' } }}>
			<Grid container rowSpacing={6} columnSpacing={2}>
				<Grid size={{ lg: 5.5, md: 5, xs: 12 }} className='hideInMbl' sx={{ alignSelf: 'center', display: { sm: 'none', md: 'none', lg: 'block' } }}>
					<Box sx={{ position: 'relative', display: 'inline-block', left: '-120px' }}>
						<motion.div
							variants={textVariant}
							initial='hidden'
							animate={controls}
							// whileInView='visible'
							// viewport={{ once: viewOnce, margin: '0px' }}
						>
							<Box
								sx={{
									height: 500,
									width: 450,
									position: 'absolute',
									top: '50%',
									left: '60%',
									zIndex: 1
								}}
								className='rectBgAnimate'
							>
								{imageExist({
									required: '/advantages',
									url: '/rectBg.png',
									alt: 'family',
									height: '100%'
								})}
							</Box>
						</motion.div>

						{/* IMAGE */}
						<motion.div
							style={{ position: 'relative', zIndex: 2 }}
							initial={{ scale: 0.75, opacity: 0 }}
							whileInView={{ scale: 1, opacity: 1 }}
							animate={controls}
							// viewport={{ once: viewOnce, margin: '-160px' }}
							transition={{
								delay: 0.5,
								type: 'spring',
								stiffness: 180,
								damping: 12,
								mass: 0.8
							}}
						>
							{imageExist({
								required: '/advantages',
								url: '/ipad.png',
								alt: 'family',
								height: '500px'
							})}
						</motion.div>
					</Box>
				</Grid>

				<Grid size={{ lg: 6.5, md: 12, xs: 12 }} p={{ lg: 0, md: 4 }}>
					<Grid container className='textCl' spacing={2}>
						<Grid size={12} sx={{ textAlign: { xs: 'left', md:'left', sm:'left' } }}>
							<AnimatedText title={'Artha Is Your Complete <br/>Financial Companion'} className='font40 fontBolder textCl' delay={true} animate={controls}/>
						</Grid>
						<Grid size={12}>
							<motion.div
								variants={containerVariant}
								initial='hidden'
								animate={controls}
								// whileInView='visible'
								// viewport={{ once: viewOnce, margin: '-100px' }}
							>
								<Grid container spacing={2}>
									<Grid size={12}>
										<p className='font20 fontBold'>Built To Simplify Calculations, Support Better Decisions, And Empower Every Stage Of Your Financial Journey.</p>
									</Grid>
									<Grid size={12}>
										<p>We started Artha with one simple mission: to make powerful financial tools accessible to everyone — from first-time investors to seasoned advisors. Whether you&apos;re planning your first SIP or optimizing your retirement strategy, Artha brings clarity and confidence to every rupee you manage.</p>
									</Grid>
									<Grid size={12} className='mb20'>
										<Grid container direction='row' rowSpacing={3} columnSpacing={2}>
											{content.map((list,i)=>(
												<Grid size={{ md:4, xs:12, sm:6 }} key={i}>
													<Stack direction='row' spacing={2} alignItems='center'>
														<Box 
															sx={{ 
																backgroundColor: '#EAD9FF',
																padding: '7px',
																borderRadius: '7px',
																height:'30px',
																width: '30px'
															}}
														>
															{imageExist({
																required: '/advantages',
																url: list.img,
																alt: `${list.img}-${i}`,
																height: '30px'
															})}
														</Box>
														<p className='fontBold'>{list.title}</p>
													</Stack>
												</Grid>
											))}
										</Grid>
									</Grid>
									<Grid size={12}>
										<Grid container wrap='nowrap' spacing={1} alignItems='center'>
											<Grid size={{ md: 7, xs: 12 }}>
												<CustomButton>Get Started For Free</CustomButton>
											</Grid>
											<Box>
												{imageExist({
													required: '/common',
													url: '/introArrow.svg',
													alt: 'introArrow',
													width: '100%',
													className: 'hideInMbl'
												})}
											</Box>
										</Grid>
									</Grid>
								</Grid>
							</motion.div>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

export default Advantages;
